module.exports = {
      id: "angle-up-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#angle-up",
      toString: function () {
        return this.url;
      }
    }